export default {
    props: {
        lineType: {
            type: String,
            default: 'solid',
        },
        lineColour: {
            type: String,
            default: '#e0e0e0'
        }
    }
}